import { render, staticRenderFns } from "./Transfer_debtor_detail.vue?vue&type=template&id=4b9abd88&scoped=true&"
import script from "./Transfer_debtor_detail.vue?vue&type=script&lang=js&"
export * from "./Transfer_debtor_detail.vue?vue&type=script&lang=js&"
import style0 from "./Transfer_debtor_detail.vue?vue&type=style&index=0&id=4b9abd88&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b9abd88",
  null
  
)

export default component.exports